// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"654717a1","231":"93432bf6","673":"c6a53bf5"}[chunkId] + ".chunk.js";
};